import moment from 'moment'
import { SUPPORTED_LANGUAGES } from '~/core/constants'

let strings = {}

const DEFAULT_LOCALE = 'en'

const getParentLocale = locale => {
  const [parent, child] = locale.split('-', 2)

  return child && parent
}

const getTranslationFile = async (locale, basePath, params = {}) => {
  const url = basePath ? new URL(`${basePath}/${locale}.json`) : `${locale}.json`

  Object.keys(params).forEach(key => {
    url.searchParams.append(key, params[key])
  })

  const resp = await fetch(url)
  const json = await resp.json()

  return json
}

export const initTranslate = async (locale, basePath, params) => {
  moment.locale(locale)

  try {
    await import(`moment/locale/${locale}.js`)
  } catch (e) {
  }

  strings = await getTranslationFile(DEFAULT_LOCALE, basePath, params)

  if (locale === DEFAULT_LOCALE) {
    return
  }

  if (SUPPORTED_LANGUAGES.includes(locale)) {
    strings = Object.assign(
      strings,
      await getTranslationFile(locale, basePath, params)
    )
  } else {
    const parentLocale = getParentLocale(locale)

    if (parentLocale !== DEFAULT_LOCALE && SUPPORTED_LANGUAGES.includes(parentLocale)) {
      strings = Object.assign(
        strings,
        await getTranslationFile(parentLocale, basePath, params)
      )
    }
  }
}

export const translate = (key, options) => {
  if (!key) {
    return ''
  }

  const data = strings[key]

  if (!data) {
    return `[[${key}]]`
  }

  const substitute = (match, s) => (
    (options && options[s]) || `{${s}}`
  )

  const result = data.replace(/\{(\w+)\}/g, substitute)

  return result
}

export default translate
